<template>
  <path vector-effect="non-scaling-stroke" d="m1.5 11.5 10-10M11.5 11.5l-10-10"/>
</template>
